import { PropsWithChildren } from 'react';
import { INavigatorContent } from './types';

export const Content: React.FC<PropsWithChildren<INavigatorContent>> = ({
  children,
}) => {
  return <>{children}</>;
};
